// import google from "assets/images/google.svg";
// import googleLight from"../../../assets/images/btn_google_signin_light_normal.png";
// import facebook from "assets/images/facebook.svg";
import Input  from "../../Input/Input";
import CheckBox from "../../Checkbox/Checkbox";
import { useNavigate } from "react-router";
import  { useCallback, ReactNode, FC, useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import { GoogleLogin } from "react-google-login";
// import {
//   GOOGLE_CLIENT_ID,
//   GOOGLE_REDIRECT_URL,
//   GOOGLE_SCOPES,
//   FACEBOOK_ID,
// } from "../../../constant";
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { Link } from "react-router-dom";
// import { isEmpty } from "@firebase/util";
// import { Button } from "@material-ui/core";
// import { type } from "os";
// import { log } from "console";
// import { getGoogleOAuthURL } from '../../../helpers/oauth'
import React from "react";

interface IInput {
  label?: any;
  name: string;
  placeholder?: string;
  type: string;
  errFl?: Boolean;
  errorMsg?: string;
  requireMsg?: string;
  flagError?: Boolean;
  require?: Boolean;
  match?: string;
  onChange?(value: string): any;
}

interface ICheckBox {
  name: string;
  require?: Boolean;
  label: ReactNode;
  errorMsg?: string;
}

interface ISocial {
  onGoogle?(value: any): any;
  onFacebook?(value: any): any;
}

interface ISubAction {
  nav: string;
  title: string;
}

interface IForm {
  setOtp?: any;
  ValidateOtp?: any;
  disableOr?: boolean;
  image?: any;
  logo?: any;
  title?: string;
  titleForgot?: string;
  des?: string;
  subDes?: string;
  subAction?: ISubAction[];
  forgotAction?: string;
  listInput: IInput[];
  listCheckbox?: ICheckBox[];
  social?: ISocial;
  buttonText: string;
  initValue?: { [k: string]: any };
  onSubmit(formvalue?: { [k: string]: any }): any;
}

const Form: FC<IForm> = function ({
  setOtp,
  ValidateOtp,
  disableOr,
  image,
  logo,
  title,
  titleForgot,
  des,
  subDes,
  subAction,
  forgotAction,
  social,
  buttonText,
  listInput,
  listCheckbox = [],
  initValue,
  onSubmit,
}: IForm) {
  const navigate = useNavigate();
  const [disable, setDisable] = useState(false);
  const [firstSubmit, setFirstSubmit] = useState(false);
  const [errFl, setErrFl] = useState<any>({});
  const [errEmpty, setErrEmpty] = useState<any>({});

  const handleSubmitForm = useCallback(
    (e: any) => {
      e.preventDefault();
      // const formData:any = e.target.value;
      const formData:any = new FormData(e.target);
      setFirstSubmit(true);
      let canSendI = true;
      let canSendC = true;
      let canSendP = true;

      const submitData:any = {};
      for (let field of formData) {
        submitData[field[0]] = field[1];
      }
      for (let index = 0; index < listInput.length; index++) {
        const { name, require, match } = listInput[index];
        if (name === "confirmPassword") {
          let validString = new RegExp("^.{8,50}$");
          if (submitData[name] != submitData['password']) {
            canSendP = false;
            setErrFl((prevState: any) => ({
              ...prevState,
              [name]: true
            }));
          } else if (!validString.test(submitData[name])) {
            canSendP = false;
          } else {
            canSendP = true;
          }
        }
        const validString = new RegExp(match!);
        if (require && !submitData[name]) {
          canSendI = false;
          setErrEmpty((prevState: any) => ({
            ...prevState,
            [name]: true
          }));
        } else if (!validString.test(submitData[name])) {
          canSendI = false;
          setErrEmpty((prevState: any) => ({
            ...prevState,
            [name]: false
          }));
          setErrFl((prevState: any) => ({
            ...prevState,
            [name]: true
          }));
        }
      }


      for (let index = 0; index < listCheckbox.length; index++) {
        const { require, name } = listCheckbox[index];
        if (require && !submitData[name]) {
          canSendC = false;
          setErrFl((prevState: any) => ({
            ...prevState,
            [name]: true
          }));
        } else {
          canSendC = true;
          setErrFl((prevState: any) => ({
            ...prevState,
            [name]: false
          }));
        }
      }
      if (!(canSendI && canSendC && canSendP)) {
        return;
      } else {
        onSubmit(submitData);
      }
    },
    [onSubmit, listCheckbox, listInput]
  );

  // const onGoogleSuccess = (value: any) => {
  //   social?.onGoogle?.(value);
  // };
  // const onFaceookSuccess = (value) => {
  //   social?.onFacebook?.(value);
  // };

  const onChangeCheckbox = (e: { target: { checked: any; }; }) => {
    setDisable(true);
    for (let index = 0; index < listCheckbox.length; index++) {
      const { require, name, errorMsg } = listCheckbox[index];
      if (e.target.checked) {
        setErrFl((prevState: any) => ({
          ...prevState,
          [name]: false
        }));
      } else {
        setErrFl((prevState: any) => ({
          ...prevState,
          [name]: true
        }));
      }
    }
  }
  const handleChange = (e: string, nameIp: string) => {
    setDisable(true);
    if (firstSubmit) {
      let item = -1;
      for (let index = 0; index < listInput.length; index++) {
        if (listInput[index].name == nameIp) {
          item = index;
        }
      }
      if (item > -1) {
        const { name, require, match } = listInput[item];
        // 
        const validString = new RegExp(match!);
        if (require && !e) {

          setErrEmpty((prevState: any) => ({
            ...prevState,
            [name]: true
          }));
        } else if (!validString.test(e)) {
          setErrEmpty((prevState: any) => ({
            ...prevState,
            [name]: false
          }));
          setErrFl((prevState: any) => ({
            ...prevState,
            [name]: true
          }));
        } else {
          setErrEmpty((prevState: any) => ({
            ...prevState,
            [name]: false
          }));
          setErrFl((prevState: any) => ({
            ...prevState,
            [name]: false
          }));
        }
      }
    }


  }

  // const handleSignInWithGoogle = () => {
  //   // window.open(`https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(window.location.href)}&scope=${GOOGLE_SCOPES}&include_granted_scopes=true&prompt=consent&access_type=offline`, '_blank', 'popup=1, status=1, width=607, height=618, toolbar=0, resizable=0')
  //   // window.open(`https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(`${window.location.origin}/login`)}&scope=${encodeURIComponent(GOOGLE_SCOPES)}&prompt=consent&access_type=offline`, '_self')
  //   window.open(
  //     getGoogleOAuthURL({
  //       clientID: GOOGLE_CLIENT_ID,
  //       scopes: GOOGLE_SCOPES,
  //       redirectUri: `${window.location.origin}${window.location.pathname}`
  //     }),
  //     '_self'
  //   )
  // }

  return (
    <>
      <div className="container-fixed">
        {image && (
          <div className="img">
            <img src={image} alt="" />
          </div>
        )}

        <div //className="container form"
          className={titleForgot ? "container formForgot" : "container form"}
        >
          {logo && (
            <div className="logo">
              <img src={logo} alt="" />
            </div>
          )}
          {title && <div className="title">{title}</div>}
          {titleForgot && <div className="titleForgot">{titleForgot}</div>}
          {subDes && <div className="sub-des">{subDes}</div>}

          <form action="" onSubmit={handleSubmitForm}> 
            {listInput.map((o) =>{              
            return(
              <Input
                defaultValue={initValue?.[o.name] || ""}
                key={o.name}
                label={o.label}
                name={o.name}
                placeholder={o.placeholder}
                type={o.type}
                onChange={(e:any) => {
                  handleChange(e, o.name)
                }}
                errorMsg={o.errorMsg}
                requireMsg={o.requireMsg}
                errFl={errFl[o.name]}
                errEmpty={errEmpty[o.name]}
              />)} 
            )}
            {listCheckbox?.map((o) => {
              return(
              <CheckBox key={o.name} name={o.name} onChange={onChangeCheckbox} label={o.label} errFl={errFl[o.name]} errorMsg={o.errorMsg} />
            )})}

            {/* <button className={titleForgot ? "button-outlined" : "button"} type='submit'>{buttonText}</button> */}
            {(!forgotAction && (
              <button
                className={!disable ? "button signup disable" : "button signup"}
                disabled={!disable}
                type="submit"
              >
                {buttonText}
              </button>
            )) || (
                <button className="button" type="submit">
                  {buttonText}
                </button>
              )}
          </form>
          {/* {subAction?.map(o => <div key={o.nav} onClick={() => navigate(o.nav)} className="nav">{o.title}</div>)} */}
          {forgotAction && (
            <div className="nav-forgot">
              <Link to="/forgot-password" className="nav-link-forgot">
                {forgotAction}
              </Link>
            </div>
          )}
          {!disableOr && (
            <div className="container-or">
              <div className="bar"></div>
              {/* <div className="text">Hoặc</div>
              <div className="bar"></div> */}
            </div>
          )}
          {/* {social && (
            <div className="sign-social">
              {social.onGoogle && (
                <div onClick={handleSignInWithGoogle} className="button">
                  <img src={googleLight} alt="" />
                </div>
              )}
              
            </div>
          )} */}
          <div className="des">
            {des}
            {/* <Link to="/signup" className='nav-signup'>Đăng ký</Link> */}
            {subAction?.map((o) => (
              <div key={o.nav} onClick={() => navigate(o.nav)} className="nav">
                {o.title}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
